const COMMITTEE_REFERRALS_ROUTE = '/committee-reports'

export { COMMITTEE_REFERRALS_ROUTE }
